import ActivityIcon from '@mui/icons-material/Fastfood'
import ActivityList from './ActivityList'

export default {
  icon: ActivityIcon,
  list: ActivityList,
}
